import { render, staticRenderFns } from "./gc-barcode-parser.vue?vue&type=template&id=b732a950&scoped=true&"
import script from "./gc-barcode-parser.vue?vue&type=script&lang=js&"
export * from "./gc-barcode-parser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b732a950",
  null
  
)

export default component.exports